import React, { useState, useEffect } from 'react';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import {
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  Box,
  Container,
  Grid,
  GridItem,
  Avatar,
  Input,
  FormControl,
  FormLabel,
  Heading,
  Button,
  Flex,
  Image,
  Alert,
  AlertIcon,
  CloseButton,
  AlertDescription,
} from '@chakra-ui/react';
import { useDispatch, useSelector } from 'react-redux';
import DatePicker from 'react-datepicker';
import { fetchProfile, _updateProfile, profileSelector } from '../../redux/slices/profile';
import ChangePass from './changepassword';
import 'react-datepicker/dist/react-datepicker.css';

function ProfilePage() {
  const dispatch = useDispatch();
  const { profile, loading } = useSelector(profileSelector);
  const [image, setImage] = useState({ preview: '', raw: '' });

  const [alert, setAlert] = useState({
    type: 'green',
    msg: '',
    visible: false,
  });
  const [initValsNew, setInitValsNew] = useState({
    first_name: '',
    last_name: '',
    email: '',
    mobile_no: '',
    company_name: '',
    designation: '',
    joined_in: '',
    avatar: '',
    _file: '',
  });
  const initialValues = {
    ...initValsNew,
  };
  const validationSchema = Yup.object({
    email: Yup.string().email('Please enter valid email').required('Email address is required'),
  });

  const onSubmit = (fields, { setStatus, setSubmitting, resetForm }) => {
    let formData = new FormData();
    formData.append('first_name', fields.first_name);
    formData.append('last_name', fields.last_name);
    formData.append('company_name', fields.company_name);
    formData.append('designation', fields.designation);
    formData.append('joined_in', fields.joined_in);
    image.raw !== '' && formData.append('avatar', image.raw);
    dispatch(_updateProfile(formData, setAlert));
  };

  const imageChange = (e) => {
    if (e.target.files.length) {
      setImage({
        preview: URL.createObjectURL(e.target.files[0]),
        raw: e.target.files[0],
      });
    }
  };
  const close = () => {
    setAlert((prevState) => {
      return {
        ...prevState,
        ...{ visible: false },
      };
    });
  };
  useEffect(() => {
    dispatch(fetchProfile());
  }, [dispatch]);

  useEffect(() => {
    //console.log("hiii");
    setInitValsNew((prevState) => {
      return {
        ...prevState,
        ...profile,
      };
    });

    // eslint-disable-next-line
  }, [loading]);

  return (
    <Container maxW='container.md' minH='90vh'>
      <Box textAlign='left' mb='5'>
        <Heading
          fontSize={['25px', '30px', '35px', '45px']}
          style={{ fontFamily: 'Mulish, sans-serif' }}
          pt='3'
        >
          Profile
        </Heading>
      </Box>
      <Tabs variant='soft-rounded'>
        <TabList>
          <Tab
            _selected={{
              boxShadow: '0px 2px 6px rgb(0 0 0 / 10%)',
              borderRadius: '10px',
              fontSize: '16px',
              color: '#000',
              padding: '5px',
            }}
            fontSize='12px'
            color='#999999'
            fontStyle='normal'
            width={{ base: '100%', md: '25%' }}
          >
            Edit Profile
          </Tab>
          <Tab
            _selected={{
              boxShadow: '0px 2px 6px rgb(0 0 0 / 10%)',
              borderRadius: '10px',
              fontSize: '16px',
              color: '#000',
              padding: '5px',
            }}
            fontSize='12px'
            color='#999999'
            fontStyle='normal'
            width={{ base: '100%', md: '25%' }}
          >
            Change Password
          </Tab>
        </TabList>
        <TabPanels>
          <TabPanel>
            <Formik
              enableReinitialize={true}
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={onSubmit}
            >
              {({
                errors,
                touched,
                isSubmitting,
                setFieldValue,
                handleBlur,
                values,
                handleChange,
                setValues,
                resetForm,
              }) => {
                return (
                  <Form noValidate>
                    <Box>
                      {alert.visible && (
                        <Alert colorScheme={alert.type} mb='3' w='80%'>
                          <AlertIcon />
                          <AlertDescription>
                            {alert.type === 'red' ? alert.msg.avatar.map((e) => e) : alert.msg}
                          </AlertDescription>
                          <CloseButton
                            position='absolute'
                            right='8px'
                            top='8px'
                            onClick={() => close()}
                          />
                        </Alert>
                      )}
                    </Box>
                    <Grid
                      templateRows={{ md: 'repeat(5, 1fr)', base: 'repeat(1, 1fr)' }}
                      templateColumns='repeat(3, 1fr)'
                      gap={4}
                    >
                      <GridItem rowSpan={{ md: 8 }} colSpan={{ base: 6, sm: 6, md: 1 }}>
                        <Flex justify='center' mt='10'>
                          {image.preview ? (
                            <Avatar src={image.preview} size='lg' />
                          ) : (
                            <Avatar
                              name={`${values.first_name} ${values.last_name}`}
                              src={values.avatar}
                              size='lg'
                            />
                          )}
                        </Flex>
                        <Flex spacing={6} justify='center'>
                          <Image
                            boxSize='20px'
                            src={'../images/camera.svg'}
                            alt=''
                            className='cursor-pointer'
                          />
                          <Box align='center' px='2' color='#47BAAD'>
                            <label htmlFor='upload-button' className='cursor-pointer'>
                              <span>Change Photo</span>
                            </label>
                            <input
                              name='_file'
                              type='file'
                              id='upload-button'
                              style={{ display: 'none' }}
                              onChange={(e) => imageChange(e)}
                            />
                          </Box>
                        </Flex>
                      </GridItem>
                      <GridItem colSpan={{ base: 6, md: 1 }}>
                        <FormControl id='first-name'>
                          <FormLabel>First Name</FormLabel>
                          <Field
                            as={Input}
                            type='text'
                            placeholder='First Name'
                            name='first_name'
                            autoComplete='off'
                            isInvalid={errors.first_name && touched.first_name}
                            bg='white'
                            borderRadius='13px'
                            className='profile-input'
                          />
                        </FormControl>
                      </GridItem>
                      <GridItem colSpan={{ base: 6, md: 1 }}>
                        <FormControl id='last_name'>
                          <FormLabel>Last Name</FormLabel>
                          <Field
                            as={Input}
                            type='text'
                            placeholder='Last Name'
                            name='last_name'
                            autoComplete='off'
                            isInvalid={errors.last_name && touched.last_name}
                            bg='white'
                            borderRadius='13px'
                            className='profile-input'
                          />
                        </FormControl>
                      </GridItem>
                      <GridItem colSpan={{ base: 6, md: 1 }} rowSpan={1}>
                        <FormControl id='email'>
                          <FormLabel>Email</FormLabel>
                          <Field
                            readOnly
                            as={Input}
                            type='text'
                            placeholder='Last Name'
                            name='email'
                            autoComplete='off'
                            isInvalid={errors.email && touched.email}
                            bg='white'
                            borderRadius='13px'
                            className='profile-input'
                          />
                        </FormControl>
                      </GridItem>
                      <GridItem colSpan={{ base: 6, md: 1 }}>
                        <FormControl id='mobile_no'>
                          <FormLabel>Phone</FormLabel>
                          <Field
                            as={Input}
                            type='text'
                            placeholder='Phone no'
                            name='mobile_no'
                            autoComplete='off'
                            isInvalid={errors.mobile_no && touched.mobile_no}
                            bg='white'
                            borderRadius='13px'
                            readOnly
                            className='profile-input'
                          />
                        </FormControl>
                      </GridItem>
                      <GridItem colSpan={{ base: 6, md: 2 }}>
                        <FormControl id='Company-name'>
                          <FormLabel>Company Name</FormLabel>
                          <Field
                            as={Input}
                            type='text'
                            placeholder='Company Name'
                            name='company_name'
                            autoComplete='off'
                            isInvalid={errors.company_name && touched.company_name}
                            bg='white'
                            borderRadius='13px'
                            className='profile-input'
                          />
                        </FormControl>
                      </GridItem>
                      <GridItem colSpan={{ base: 6, md: 1 }}>
                        <FormControl id='Designation'>
                          <FormLabel>Designation</FormLabel>
                          <Field
                            as={Input}
                            type='text'
                            placeholder='Designation'
                            name='designation'
                            autoComplete='off'
                            isInvalid={errors.designation && touched.designation}
                            bg='white'
                            borderRadius='13px'
                            className='profile-input'
                          />
                        </FormControl>
                      </GridItem>
                      <GridItem colSpan={{ base: 6, md: 1 }}>
                        <FormControl id='Joined'>
                          <FormLabel>Joined In</FormLabel>

                          <DatePicker
                            selected={
                              values.joined_in !== '' && values.joined_in !== 'null'
                                ? new Date(values.joined_in)
                                : new Date()
                            }
                            dateFormat='dd-MM-yyyy'
                            className='chakra-input profile-input css-1b0sgtj'
                            name='joined_in'
                            onChange={(date) => setFieldValue('joined_in', date)}
                          />
                        </FormControl>
                      </GridItem>
                      <GridItem colSpan={{ base: 6, md: 1 }}>
                        <Button
                          colorScheme='teal'
                          size='lg'
                          w={{ md: '100%', base: '100%' }}
                          bg='linear-gradient(266.9deg, #43B0A3 0.58%, rgba(67, 176, 163, 0.61) 86.97%);'
                          _hover={{
                            bg: 'linear-gradient(266.9deg, #43B0A3 0.58%, rgba(67, 176, 163, 0.61) 86.97%);',
                          }}
                          type='submit'
                          className='button-text'
                        >
                          Save Changes
                        </Button>
                      </GridItem>
                      {/* <GridItem colSpan={{ base: 6, md: 1 }}>&nbsp;</GridItem> */}
                    </Grid>
                  </Form>
                );
              }}
            </Formik>
          </TabPanel>
          <TabPanel>
            <ChangePass />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Container>
  );
}

export default ProfilePage;
